var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7625 14.9999L21.25 10.5499C21.4887 10.3079 21.6215 9.98102 21.6192 9.64111C21.6168 9.3012 21.4795 8.97614 21.2375 8.73745C20.9955 8.49875 20.6686 8.36597 20.3287 8.36832C19.9888 8.37066 19.6637 8.50794 19.425 8.74995L15 13.2374L10.575 8.83745C10.3408 8.60463 10.024 8.47396 9.69377 8.47396C9.36354 8.47396 9.04672 8.60463 8.81252 8.83745C8.69536 8.95365 8.60237 9.0919 8.53891 9.24423C8.47545 9.39655 8.44277 9.55993 8.44277 9.72495C8.44277 9.88996 8.47545 10.0533 8.53891 10.2057C8.60237 10.358 8.69536 10.4962 8.81252 10.6124L13.2375 14.9999L8.75002 19.4499C8.51133 19.692 8.37855 20.0189 8.38089 20.3588C8.38323 20.6987 8.52051 21.0238 8.76252 21.2624C9.00453 21.5011 9.33145 21.6339 9.67136 21.6316C10.0113 21.6292 10.3363 21.492 10.575 21.2499L15 16.7624L19.425 21.1624C19.6592 21.3953 19.976 21.5259 20.3063 21.5259C20.6365 21.5259 20.9533 21.3953 21.1875 21.1624C21.3047 21.0462 21.3977 20.908 21.4611 20.7557C21.5246 20.6033 21.5573 20.44 21.5573 20.2749C21.5573 20.1099 21.5246 19.9466 21.4611 19.7942C21.3977 19.6419 21.3047 19.5037 21.1875 19.3874L16.7625 14.9999Z",
    fill: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtn);
export default __webpack_public_path__ + "static/media/closeBtn.7c5528bb5c7410d5e01a25d5ca1043d6.svg";
export { ForwardRef as ReactComponent };